var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar",attrs:{"id":"masthead"}},[_c('div',{staticClass:"container d-flex align-items-center"},[_c('logo',{attrs:{"height":34,"light":true}}),_c('main-nav'),_c('nav-right',{attrs:{"toggle":'MainNavToggle'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }